import { BaseUniformData } from './pipeline-base';

export const colourMatrixSize = 20;

export interface ColourMatrixUniformData extends BaseUniformData {
  matrix_4x5: Float32Array;
  alpha: number;
}

// ! Made to work with pixels already on the canvas, not supplied by another texture. This process is not working right now, maybe cannot ever.

// export class ColourMatrixPipeline extends BasePipeline {

//   constructor() {
//     super(vertex, fragColourMatrix);
//   }

//   protected InitShaderProps(shaderProgram:WebGLProgram) {
//     super.InitShaderProps(shaderProgram);

//     this.shaderProgramProps['u_textureSize'] = this.gl.getUniformLocation(shaderProgram, "uTextureSize");
//     this.shaderProgramProps['u_thickness'] = this.gl.getUniformLocation(shaderProgram, "uThickness");
//   }

//    // Exists just for "uniformData" type extension.
//   public Draw(uniformData:ColourMatrixUniformData):void {
//     super.Draw(uniformData);
//   }

//   // Exists just for "uniformData" type extension.
//   public DrawOnceForPixelData(uniformData:ColourMatrixUniformData):Uint8Array|null {
//     return super.DrawOnceForPixelData(uniformData)
//   }

//   protected SetUniforms(data:ColourMatrixUniformData) {
//     super.SetUniforms(data);
//     this.gl.uniform2fv(this.shaderProgramProps['u_textureSize'], [this.canvasWidth, this.canvasHeight]);
//     this.gl.uniform1f(this.shaderProgramProps['u_thickness'], data.thickness);
//   }
// }
